import { useState, useEffect } from "react";
import styles from "./Footer.module.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  FaLinkedin,
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaPhoneAlt,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6"; 
import { IoMdMail, IoMdSend } from "react-icons/io";
import { api } from "../../store/slices/authSlice";


export default function Footer() {
  const { t, i18n } = useTranslation();
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await api.get("/settings");
        if (res.data.code === 200 && res.data.data.length > 0) {
          setSettings(res.data.data[0]);
        }
      } catch (err) {
        console.error("Error fetching settings:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, [i18n.language]);

  if (loading || !settings) return null;

  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.topSection}>
          <div className={styles.brandCol}>
            <img
              src={settings.logo || "/logo-placeholder.png"}
              alt={settings.name}
              className={styles.logo}
            />
            <p className={styles.description}>{settings.desc}</p>
          </div>
          <div className={styles.linkCol}>
            <h4 className={styles.colTitle}>{t("footer.company")}</h4>

            <ul className={styles.linkList}>
              <li>
                <Link to="/products">{t("footer.catalog")}</Link>
              </li>
              <li>
                <Link to="/raw-materials">{t("footer.materials")}</Link>
              </li>
              <li>
                <Link to="/top-formula">{t("footer.formulas")}</Link>
              </li>
              <li>
                <Link to="/about">{t("footer.aboutUs")}</Link>
              </li>
              <li>
                <Link to="/terms">{t("footer.terms")}</Link>
              </li>
            </ul>
          </div>

          <div className={styles.contactCol}>
            <h4 className={styles.colTitle}>{t("footer.contactUs")}</h4>

            <div className={styles.contactInfo}>
              <div className={styles.infoItem}>
                <FaPhoneAlt size={16} /> <span>{settings.phone}</span>
              </div>
              <div className={styles.infoItem}>
                <IoMdMail size={16} /> <span>{settings.email}</span>
              </div>
            </div>
          </div>
          <div className={styles.socialLinks}>
            <h4 className={styles.colTitle}>{t("footer.socials")}</h4>
            <div className={styles.socials}>
              {settings.facebook && (
                <a href={settings.facebook} target="_blank" rel="noreferrer">
                  <FaFacebook size={20} />
                </a>
              )}
              {settings.xUrl && (
                <a href={settings.xUrl} target="_blank" rel="noreferrer">
                  <FaXTwitter size={20} />
                </a>
              )}
              {settings.linkedin && (
                <a href={settings.linkedin} target="_blank" rel="noreferrer">
                  <FaLinkedin size={20} />
                </a>
              )}
              {settings.instagram && (
                <a href={settings.instagram} target="_blank" rel="noreferrer">
                  <FaInstagram size={20} />
                </a>
              )}
            </div>
          </div>
        </div>

        <a href="https://brmja.tech/" target="_blank" rel="noopener noreferrer">
          {t("copyright")}
        </a>
      </div>
    </footer>
  );
}
